// Shared treatment metadata: keys map to translation keys + URL slugs + images
// Images sourced from the official Kosmedico Zürich CDN.

const SHORTPIXEL = (file) =>
  `https://spcdn.shortpixel.ai/spio/ret_img,q_cdnize,to_auto,s_webp:avif/kosmedico.zuerich/wp-content/uploads/${file}`;

export const TREATMENTS = [
  {
    key: "botox",
    slug: "botox",
    hero: SHORTPIXEL("2024/06/Design-sem-nome-2024-06-03T113452.179-1024x576.png"),
    gallery: [
      SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T161256.133-1024x576.png"),
      SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T161339.786-1024x576.png"),
      SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T161417.473-1024x576.png"),
    ],
  },
  {
    key: "hyaluron",
    slug: "hialuronico",
    hero: SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T170145.842-1024x576.png"),
    gallery: [
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T170202.779-1024x576.png"),
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T170221.567-1024x576.png"),
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T170237.054-1024x576.png"),
    ],
  },
  {
    key: "nano",
    slug: "nanoneedling",
    hero: SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T155812.008-1024x576.png"),
    gallery: [
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T160127.179-1024x576.png"),
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T160837.087-1024x576.png"),
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T161200.557-1024x576.png"),
    ],
  },
  {
    key: "lippen",
    slug: "labios",
    hero: SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T171326.836-1024x576.png"),
    gallery: [
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T171348.295-1024x576.png"),
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T171448.300-1024x576.png"),
      SHORTPIXEL("2024/06/Design-sem-nome-2024-06-05T171432.489-1024x576.png"),
    ],
  },
  {
    key: "sculptra",
    slug: "sculptra",
    hero: SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T151332.222-1024x576.png"),
    gallery: [
      SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T151257.109-1-1024x576.png"),
      SHORTPIXEL("2024/05/Design-sem-nome-2024-05-17T175727.850-1024x576.png"),
      SHORTPIXEL("2024/04/Design-sem-nome-2024-04-16T194334.636-1024x576.png"),
    ],
  },
];

export const HOME_GALLERY = [
  SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T151257.109-1-1024x576.png"),
  SHORTPIXEL("2024/05/Design-sem-nome-2024-05-17T175727.850-1024x576.png"),
  SHORTPIXEL("2024/04/Design-sem-nome-2024-04-16T194334.636-1024x576.png"),
  SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T151332.222-1024x576.png"),
];

export const TREATMENT_THUMBS = {
  botox: SHORTPIXEL("2024/04/Design-sem-nome-2024-04-16T191613.721.png"),
  nano: SHORTPIXEL("2024/04/3.png"),
  hyaluron: SHORTPIXEL("2024/04/5.png"),
  lippen: SHORTPIXEL("2024/04/6.png"),
  sculptra: SHORTPIXEL("2024/05/Design-sem-nome-2024-05-27T151332.222-1024x576.png"),
};

export const getTreatmentBySlug = (slug) =>
  TREATMENTS.find((t) => t.slug === slug);
